import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="bg-ink text-stone-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo dark />
          <p className="mt-6 font-cormorant text-xl leading-relaxed text-stone-400 max-w-sm">
            Every woman — a stay-at-home mom, a working mom, a grandmother — deserves to understand
            what AI means for her day-to-day life, her work and her family. In plain language. Together.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-stone-500 mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            {[["Why It Matters", "/#problem"], ["Who We Help", "/#who"], ["Learn", "/#learn"],
              ["Join", "/#join"]].map(([label, href]) => (
              <li key={label}><a href={href} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                 className="hover:text-cream transition-colors duration-300">{label}</a></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-stone-500 mb-5">Reach us</p>
          <a href="mailto:aiforwomencommunity@gmail.com" data-testid="footer-email-link"
             className="text-sm hover:text-cream transition-colors duration-300 break-all">
            aiforwomencommunity@gmail.com
          </a>
          <p className="mt-8 text-xs text-stone-500 leading-relaxed">
            AIWC — AI for Women Community. A free educational community. We never ask for
            passwords, card details or payments by email.
          </p>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-stone-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-xs text-stone-500">© {new Date().getFullYear()} AIWC — AI for Women Community. All rights reserved.</p>
        <a href="/admin" data-testid="footer-admin-link" className="text-xs text-stone-500 hover:text-cream transition-colors duration-300">Admin</a>
      </div>
    </div>
  </footer>
);
